import * as Yup from 'yup';

const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;

export default [
  Yup.object().shape({
    userName: Yup.string().required('Username is required'),
  }),
  Yup.object().shape({
    password: Yup.string()
      .min(4, 'Password is too short - should be 4 chars minimum.')
      .max(24, 'Password must not exceed 24 characters')
      .matches(
        PWD_REGEX,
        ' 4 to 24 characters, Must begin with a letter,and letters, numbers, underscores, hyphens allowed.'
      ),
    confirmPassword: Yup.string()
      .when('password', (pass: string[], schema) => {
        if (pass[0]) {
          return schema.required('Confirm Password is required');
        }
        return schema;
      })
      .oneOf([Yup.ref('password')], 'Confirm Password does not match'),
    email: Yup.string().email(),
    firstName: Yup.string(),
    lastName: Yup.string(),
  }),
];
